export const FORM_VALUE_ENGLISH = 'en';
export const FORM_VALUE_FRENCH = 'fr';

const FHIR_VALUE_ENGLISH = {
  coding: [
    {
      code: FORM_VALUE_ENGLISH,
      display: 'English',
    },
  ],
  text: 'English',
};
const FHIR_VALUE_FRENCH = {
  coding: [
    {
      code: FORM_VALUE_FRENCH,
      display: 'French',
    },
  ],
  text: 'French',
};

export const FHIR_LANGUAGE_VALUES = {
  [FORM_VALUE_ENGLISH]: FHIR_VALUE_ENGLISH,
  [FORM_VALUE_FRENCH]: FHIR_VALUE_FRENCH,
};
